import { render } from "./SendGift.vue?vue&type=template&id=089fd216&scoped=true"
import script from "./SendGift.vue?vue&type=script&lang=js"
export * from "./SendGift.vue?vue&type=script&lang=js"

import "./SendGift.vue?vue&type=style&index=0&id=089fd216&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-089fd216"

export default script